import { API_URL, ASSETS, URL, PLATFORM_FEE } from '../config.js';
import { printdDate } from '../helper.js';
import View from './View';

class adminProductListView extends View {
  _parentElement = document.querySelector('.main');
  _errorMessage = 'Admin Product List View Error Message';
  _message = 'Admin Product List View Success Message';

  addHandlerProductSearch(handler) {
    const searchForm = document.querySelector('.productlist__search--form');
    if (!searchForm) return;

    searchForm.addEventListener('submit', e => {
      e.preventDefault();
      e.stopImmediatePropagation();
      const dataArr = [...new FormData(searchForm)];
      const data = Object.fromEntries(dataArr);

      handler(data);
    });
  }

  addHandlerEditProduct(handler) {
    const products = document.querySelectorAll('.productlist__item--detail');
    if (!products) return;
    products.forEach(product => {
      product.addEventListener('click', e => {
        e.preventDefault();
        handler(product.dataset.id, 'id');
      });
    });
  }

  _generateMarkup() {
    this._parentElement = document.querySelector('.profile__detail');

    const products = this._data;

    let productMarkup;
    if (Array.isArray(products)) {
      this._parentElement = document.querySelector('.orderlist-product');
      productMarkup = products
        .map(
          product => `
                    <li class="orderlist__item" >
                <div class="orderList__item--container">
                  <a href="/product?${product.slug}" target="_blank" class="link">
                    <div class="orderlist__item--img">
                      <img
                        src="${ASSETS}images/product/${product.imageCover}"
                        alt="${product.tag}"
                      />
                    </div>
                  </a>
                  <div  class=" productlist__item--detail" data-id=${product._id}>
                    <div class="">
                      <h3 class="orderlist__item--title">
                        ${product.brand}
                      </h3>
                      <h4 class="orderlist__item--tag">${product.tag}</h4>
                      <p class="paragraph paragraph__small">#${product._id}</p>
                      
                    </div>

                    <div class="orderlist__item--price">
                      <span class="orderlist__item--discounted-price"
                        >₹ ${product.price}</span
                      >
                      ${
                        product.mrp && product.mrp - product.price > 0
                          ? `<span class="orderlist__item--mrp">₹ ${product.mrp}</span> 
                      <span class="orderlist__item--discount-percent"
                        >(${Math.ceil(((product.mrp - product.price) * 100) / product.mrp)}% OFF)</span
                      >`
                          : ''
                      }
                      
                    </div>
                  </div>
                </div>
              

      `,
        )
        .reverse()
        .join('');
    }

    return `
    ${
      this._parentElement.classList.contains('profile__detail')
        ? `        
      <form action="#" class="orderlist__search--form productlist__search--form">
      <label for="">Search Using:</label>
          <div class="orderlist__search--terms">
            <div class="orderlist__search--props">         
              <input type="string" name="slug" id="" placeholder="slug" />
            </div>
 
          </div>
          <div class="orderlist__search--btn-container">
            <button type="search" class="btn orderlist__search--btn productlist__search--btn">
              Search
            </button>
          </div>
        </form>`
        : ``
    }

    
        <div class="row  orderlist-product">
        ${
          Array.isArray(products)
            ? `
        <div class="orderlist__head">
          <h2 class="orderlist__heading orderlist__admin">
          Total Products: ${products.length}  |  
          In stock: ${products.filter(el => el.inStock).length}  |  
          Out of stock: ${products.filter(el => !el.inStock).length}  |  
          Inactive: ${products.filter(el => !el.active).length}</h2>
        </div>

        <div class="orderlist__container">
          <div class="orderlist__items--container">
            <ul class="orderlist__items">
            ${productMarkup}
            </ul>
          </div>
        </div>          
          
          `
            : ``
        }


        
      </div>
    `;
  }
}

export default new adminProductListView();
